// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list__item {
  background-color: var(--secondary-color);
  border: var(--border);
  border-radius: 5px;
  padding: 10px;
  color: 000;
  margin: 5px 0;
  width: 100%;
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.list__item:hover {
  background-color: color-mix(in srgb, var(--primary-color) 20%, white);
}

.list__item-ul {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.delete-button {
  font-size: 1.3em;
  border: none;
  background: none;
}

.delete-button:hover {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/components/List/ListItem/ListItem.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".list__item {\n  background-color: var(--secondary-color);\n  border: var(--border);\n  border-radius: 5px;\n  padding: 10px;\n  color: 000;\n  margin: 5px 0;\n  width: 100%;\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.list__item:hover {\n  background-color: color-mix(in srgb, var(--primary-color) 20%, white);\n}\n\n.list__item-ul {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.delete-button {\n  font-size: 1.3em;\n  border: none;\n  background: none;\n}\n\n.delete-button:hover {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
